import { Card, CardContent, Typography, Stack, Button, Divider } from '@mui/material'
import RoomIcon from '@mui/icons-material/Room'
import PhoneIcon from '@mui/icons-material/Phone'
import AccessTimeIcon from '@mui/icons-material/AccessTime'

const onDirections = (c) =>
  window.open(`https://www.google.com/maps/dir/?api=1&destination=${c.lat},${c.lng}`, '_blank')

export default function CompanyCard({ company, isNearest }) {
  return (
    <Card variant='outlined' sx={{ borderRadius: 2 }}>
      <CardContent>
        <Typography variant='subtitle1' fontWeight={600} gutterBottom>
          {company.workshop}
        </Typography>
        {company.distance && (
          <Typography variant='caption' color='primary' sx={{ mb: 1, display: 'block' }}>
            {isNearest ? 'Nearest - ' : ''}
            {company.distance.toFixed(1)} km away
          </Typography>
        )}
        <Stack direction='row' spacing={1.5} alignItems='flex-start' mb={1}>
          <RoomIcon fontSize='small' sx={{ mt: '2px' }} />
          <Typography variant='body2' color='text.secondary'>
            {company.address}
          </Typography>
        </Stack>
        {company.contact && (
          <Stack direction='row' spacing={1.5} alignItems='center' mb={1}>
            <PhoneIcon fontSize='small' />
            <Typography variant='body2' color='text.secondary'>
              {company.contact}
            </Typography>
          </Stack>
        )}
        {company.operatingHour && (
          <Stack direction='row' spacing={1.5} alignItems='flex-start' mb={1.5}>
            <AccessTimeIcon fontSize='small' sx={{ mt: '2px' }} />
            <Typography variant='body2' color='text.secondary' whiteSpace='pre-line'>
              {company.operatingHour}
            </Typography>
          </Stack>
        )}
        <Divider sx={{ my: 1.5 }} />
        <Stack direction='row' spacing={1}>
          <Button variant='contained' size='small' onClick={() => onDirections(company)}>
            Directions
          </Button>
          <Button
            variant='outlined'
            size='small'
            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
              company.workshop
            )}`}
            target='_blank'
            rel='noopener noreferrer'
          >
            Open in Maps
          </Button>
        </Stack>
      </CardContent>
    </Card>
  )
}
